module.exports = __webpack_public_path__ + "static/mekari-black-6cd76121631bc12f8551217f8a1af336.svg";